import { useState } from "react";
import { Button, Icon } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { serverGql } from "__generated__/serverGql";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";
import serverClient from "utils/apollo/serverClient";
import { assertPresence } from "utils/assertions";
import { MdArrowForward } from "react-icons/md";

const fragment = gql(/* GraphQL */ `
  fragment StripePortalButton on Brand {
    id
    stripeCustomerId
  }
`);

const mutation = serverGql(/* ServerGraphQL */ `
  mutation GetStripeCustomerPortalSession($brandId: UUID!, $returnUrl: String) {
    createStripeCustomerPortalSession(brandId: $brandId, returnUrl: $returnUrl) {
      url
    }
  }
`);

type Props = {
  brand: FragmentType<typeof fragment>;
};

export default function StripePortalButton({ brand: brandFragment }: Props) {
  const brand = getFragmentData(fragment, brandFragment);

  const [isLoading, setIsLoading] = useState(false);

  const { showErrorToast } = useAsyncCompleteToast();

  const handleClick = () => {
    setIsLoading(true);

    const returnUrl = window.location.href;

    serverClient
      .mutate({ mutation, variables: { brandId: brand.id, returnUrl } })
      .then((response) => {
        const url = response.data?.createStripeCustomerPortalSession?.url;
        assertPresence(url, "Expected URL to be defined");
        window.location.href = url;
      })
      .catch((reason) => {
        showErrorToast(reason);
        setIsLoading(false);
      });
  };

  return (
    <Button
      colorScheme="pinkButton"
      isDisabled={!brand?.stripeCustomerId}
      isLoading={isLoading}
      onClick={handleClick}
      rightIcon={<Icon as={MdArrowForward} mr={-2} />}
    >
      Go To Billing Portal
    </Button>
  );
}
